import { render, staticRenderFns } from "./main-footer.vue?vue&type=template&id=58c7ec7e&scoped=true&"
import script from "./main-footer.vue?vue&type=script&lang=ts&"
export * from "./main-footer.vue?vue&type=script&lang=ts&"
import style0 from "./main-footer.vue?vue&type=style&index=0&id=58c7ec7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c7ec7e",
  null
  
)

export default component.exports